module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper pt-header65"
  }, [_c('header', {
    staticClass: "gheader -white gheader-fix"
  }, [_vm._m(0), (!_vm.notInput()) ? _c('button', {
    staticClass: "gheader__start-btn btn01 -w110",
    on: {
      "click": _vm.onClickSave
    }
  }, [_c('span', [_vm._v("確認依頼")])]) : _c('button', {
    staticClass: "gheader__start-btn btnXX -unavailable -w110"
  }, [_c('span', [_vm._v("確認依頼")])])]), _c('div', {
    staticClass: "container bg04"
  }, [_c('div', {
    staticClass: "row heading-010801 mb20"
  }, [_vm._m(1), _c('p', {
    staticClass: "heading-010801__txt"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.proposeHelp()
      }
    }
  }, [_vm._v("ヘルプ")])])]), _c('table', {
    staticClass: "profile-contents"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "profile-contents__body"
  }, [_vm._m(2), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposeTitle),
      expression: "proposeTitle"
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": "30",
      "rows": "2"
    },
    domProps: {
      "value": (_vm.proposeTitle)
    },
    on: {
      "change": function($event) {
        _vm.rmEmoji(_vm.proposeTitle, 'title')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.proposeTitle = $event.target.value
      }
    }
  })])]), _c('tr', [_c('td', {
    staticClass: "profile-contents__body"
  }, [_vm._m(3), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposeContent),
      expression: "proposeContent"
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": "1000",
      "rows": "7"
    },
    domProps: {
      "value": (_vm.proposeContent)
    },
    on: {
      "change": function($event) {
        _vm.rmEmoji(_vm.proposeContent, 'content')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.proposeContent = $event.target.value
      }
    }
  })])]), _vm._l((_vm.proposeImages), function(propose_image, index) {
    return _c('tr', [_c('td', {
      staticClass: "profile-contents__body"
    }, [_c('div', {
      staticClass: "round-square-img"
    }, [_c('img', {
      attrs: {
        "src": propose_image['propose_image_path'] + '?token=' + _vm.authToken + '&timestamp=' + _vm.timeStamp
      }
    }), _c('span', {
      staticClass: "round-square-img__close"
    }, [_c('img', {
      attrs: {
        "src": require("../images/icon_close_02.png"),
        "alt": "画像を削除"
      },
      on: {
        "click": function($event) {
          _vm.deleteProposeImage(index)
        }
      }
    })])])])])
  }), (_vm.proposeImages.length < 3) ? _c('tr', [_c('td', {
    staticClass: "profile-contents__body"
  }, [_c('button', {
    staticClass: "btn02 -camera",
    on: {
      "click": _vm.onFileDummyClick
    }
  }, [_c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "file",
      "type": "file"
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _c('span', [_vm._v("写真を追加する")])])])]) : _vm._e(), (_vm.uploadError && _vm.upFlg) ? _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v("画像はjpgかpng形式でお願いします")])]) : _vm._e()], 2)]), _vm._m(4), (!_vm.isInputedIdeas()) ? _c('div', {
    staticClass: "row bg06 text-center"
  }, [_c('span', {
    staticStyle: {
      "color": "#F00"
    }
  }, [_vm._v(" ※必須入力")])]) : _vm._e(), _c('div', {
    staticClass: "row bg06"
  }, [_c('div', {
    staticClass: "btn-select inner"
  }, [_c('nav', {
    staticClass: "btn-select__nav -bottom-line"
  }, [_c('h3', {
    staticClass: "btn-select__nav__title"
  }, [_vm._v("CSV")]), _c('button', {
    staticClass: "btn-select__nav__btn",
    class: _vm.ideaClass('ideaPeaceMing'),
    on: {
      "click": function($event) {
        _vm.changeIdea('ideaPeaceMing')
      }
    }
  }, [_c('span', [_vm._v("安心")])]), _c('button', {
    staticClass: "btn-select__nav__btn",
    class: _vm.ideaClass('ideaSincere'),
    on: {
      "click": function($event) {
        _vm.changeIdea('ideaSincere')
      }
    }
  }, [_c('span', [_vm._v("誠実")])]), _c('button', {
    staticClass: "btn-select__nav__btn",
    class: _vm.ideaClass('ideaExcitement'),
    on: {
      "click": function($event) {
        _vm.changeIdea('ideaExcitement')
      }
    }
  }, [_c('span', [_vm._v("感動")])]), _c('button', {
    staticClass: "btn-select__nav__btn",
    class: _vm.ideaClass('ideaComfortable'),
    on: {
      "click": function($event) {
        _vm.changeIdea('ideaComfortable')
      }
    }
  }, [_c('span', [_vm._v("快適")])]), _c('button', {
    staticClass: "btn-select__nav__btn",
    class: _vm.ideaClass('ideaCreation'),
    on: {
      "click": function($event) {
        _vm.changeIdea('ideaCreation')
      }
    }
  }, [_c('span', [_vm._v("創造")])])]), _c('nav', {
    staticClass: "btn-select__nav"
  }, [_c('h3', {
    staticClass: "btn-select__nav__title"
  }, [_vm._v("ESV")]), _c('button', {
    staticClass: "btn-select__nav__btn",
    class: _vm.ideaClass('ideaCivility'),
    on: {
      "click": function($event) {
        _vm.changeIdea('ideaCivility')
      }
    }
  }, [_c('span', [_vm._v("礼節")])]), _c('button', {
    staticClass: "btn-select__nav__btn",
    class: _vm.ideaClass('ideaImagination'),
    on: {
      "click": function($event) {
        _vm.changeIdea('ideaImagination')
      }
    }
  }, [_c('span', [_vm._v("想像")])]), _c('button', {
    staticClass: "btn-select__nav__btn",
    class: _vm.ideaClass('ideaSympathy'),
    on: {
      "click": function($event) {
        _vm.changeIdea('ideaSympathy')
      }
    }
  }, [_c('span', [_vm._v("感応")])]), _c('button', {
    staticClass: "btn-select__nav__btn",
    class: _vm.ideaClass('ideaExpression'),
    on: {
      "click": function($event) {
        _vm.changeIdea('ideaExpression')
      }
    }
  }, [_c('span', [_vm._v("表現")])]), _c('button', {
    staticClass: "btn-select__nav__btn",
    class: _vm.ideaClass('ideaChallengeDream'),
    on: {
      "click": function($event) {
        _vm.changeIdea('ideaChallengeDream')
      }
    }
  }, [_c('span', [_vm._v("挑夢")])])])])]), _c('div', {
    staticClass: "offer-members",
    style: (_vm.padding())
  }, [_vm._m(5), (_vm.profileCallbackFlag) ? _c('div', {
    staticClass: "user-outline mb15"
  }, [(_vm.profileImagePath) ? _c('div', {
    staticClass: "user-outline__img"
  }, [_c('img', {
    attrs: {
      "src": _vm.profileImagePath + '?token=' + _vm.authToken + '&timestamp=' + _vm.timeStamp
    }
  })]) : _c('div', {
    staticClass: "user-outline__img"
  }, [_c('img', {
    attrs: {
      "src": require("../images/img_profile.png"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "user-outline__body"
  }, [_c('p', {
    staticClass: "user-outline__body__role"
  }, [_vm._v(_vm._s(_vm.profile.attributes['shop-name']) + " " + _vm._s(_vm.profile.attributes['user-type-name']))]), _c('h3', {
    staticClass: "user-outline__body__name"
  }, [_vm._v(_vm._s(_vm.getUserFullName))])])]) : _vm._e(), _c('div', {
    staticClass: "frame01 offer-members__list"
  }, [_vm._m(6), _vm._l((_vm.jointUsers), function(joint_user, index) {
    return _c('div', {
      staticClass: "offer-members__list__item"
    }, [_c('div', {
      staticClass: "user-outline"
    }, [(joint_user['profile_image_path']) ? _c('div', {
      staticClass: "user-outline__img"
    }, [_c('img', {
      attrs: {
        "src": joint_user['profile_image_path'] + '?token=' + _vm.authToken + '&timestamp=' + _vm.timeStamp
      }
    })]) : _c('div', {
      staticClass: "user-outline__img"
    }, [_c('img', {
      attrs: {
        "src": require("../images/img_profile.png"),
        "alt": ""
      }
    })]), _c('div', {
      staticClass: "user-outline__body"
    }, [_c('p', {
      staticClass: "user-outline__body__role fz11"
    }, [_vm._v(_vm._s(joint_user['shop_name']) + " " + _vm._s(joint_user['user_type_name']))]), _c('h3', {
      staticClass: "user-outline__body__name fz16"
    }, [_vm._v(_vm._s(joint_user['user_name']) + " " + _vm._s(joint_user['user_firstname']))])])]), _c('div', {
      staticClass: "offer-members__list__item__delete",
      on: {
        "click": function($event) {
          _vm.deleteJoin(index)
        }
      }
    }, [_c('span', [_vm._v("削除")])])])
  }), (_vm.jointUsers.length < 2) ? _c('div', {
    staticClass: "offer-members__search"
  }, [_c('div', {
    staticClass: "offer-members__search__wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchUserName),
      expression: "searchUserName"
    }],
    staticClass: "form-control offer-members__search__form",
    attrs: {
      "type": "text",
      "placeholder": "名前を入力"
    },
    domProps: {
      "value": (_vm.searchUserName)
    },
    on: {
      "change": function($event) {
        _vm.rmEmoji(_vm.searchUserName, 'name')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchUserName = $event.target.value
      }
    }
  }), _c('button', {
    staticClass: "offer-members__search__btn",
    on: {
      "click": _vm.joinUsersSearch
    }
  })]), _c('div', {
    staticClass: "frame01 offer-members__search__list",
    class: _vm.searchOpen()
  }, [(_vm.searchCallbackFlag) ? _c('div', _vm._l((_vm.joinUsers), function(joinUser) {
    return _c('div', [_c('div', {
      staticClass: "user-outline",
      on: {
        "click": function($event) {
          _vm.addJoin(joinUser)
        }
      }
    }, [(joinUser.attributes['profile-image-path']) ? _c('div', {
      staticClass: "user-outline__img"
    }, [_c('img', {
      attrs: {
        "src": joinUser.attributes['profile-image-path'] + '?token=' + _vm.authToken + '&timestamp=' + _vm.timeStamp
      }
    })]) : _c('div', {
      staticClass: "user-outline__img"
    }, [_c('img', {
      attrs: {
        "src": require("../images/img_profile.png"),
        "alt": ""
      }
    })]), _c('div', {
      staticClass: "user-outline__body"
    }, [_c('p', {
      staticClass: "user-outline__body__role fz11"
    }, [_vm._v(_vm._s(joinUser.attributes['shop-name']) + " " + _vm._s(joinUser.attributes['user-type-name']))]), _c('h3', {
      staticClass: "user-outline__body__name fz16"
    }, [_vm._v(_vm._s(joinUser.attributes['user-name']) + " " + _vm._s(joinUser.attributes['user-firstname']))])])])])
  }), 0) : _vm._e()])]) : _vm._e()], 2)]), _c('button', {
    staticClass: "hide",
    attrs: {
      "id": "proposeHelpModalButton",
      "type": "button",
      "data-backdrop": "static",
      "data-toggle": "modal",
      "data-target": "#proposeHelpModal"
    }
  }, [_vm._v("モーダル発火用")]), _vm._m(7), _c('button', {
    staticClass: "hide",
    attrs: {
      "id": "proposeModalButton",
      "type": "button",
      "data-backdrop": "static",
      "data-toggle": "modal",
      "data-target": "#proposeModal"
    }
  }, [_vm._v("モーダル発火用")]), _c('div', {
    staticClass: "help-modal",
    attrs: {
      "id": "proposeModal"
    }
  }, [_c('div', {
    staticClass: "help-modal__body bg03",
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    }
  }, [_vm._m(8), _vm._m(9), _c('button', {
    staticClass: "btn01 moral-going__modal-btn",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.goProposeList
    }
  }, [_c('span', [_vm._v("閉じる")])])])]), _vm._m(10)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gheader__link-back"
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("戻る")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "heading-010801__title moralcheck-title"
  }, [_c('img', {
    attrs: {
      "src": require("../images/img_title_02.png"),
      "alt": "あそびゴコロから心を豊かにしてイイじゃにゃい！"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "profile-contents__body__sub-txt fz13 brown"
  }, [_c('span', {
    staticClass: "fz16 bold brown"
  }, [_vm._v("提案タイトル")]), _vm._v("（最大30文字）"), _c('span', {
    staticStyle: {
      "color": "#F00"
    }
  }, [_vm._v(" ※必須入力")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "profile-contents__body__sub-txt fz13 brown"
  }, [_c('span', {
    staticClass: "fz16 bold brown"
  }, [_vm._v("提案内容")]), _vm._v("（最大1,000文字）"), _c('span', {
    staticStyle: {
      "color": "#F00"
    }
  }, [_vm._v(" ※必須入力")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row heading-010801-2"
  }, [_c('h2', {
    staticClass: "moralcheck-title fz16 brown bold"
  }, [_vm._v("当てはまる理念を"), _c('br'), _vm._v("すべて選んでねだニャン！")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "fz12 brown mb10"
  }, [_c('span', {
    staticClass: "bold brown"
  }, [_vm._v("提案者")]), _vm._v("(あなた)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "fz12 brown mb10"
  }, [_c('span', {
    staticClass: "bold brown"
  }, [_vm._v("一緒に提案する人")]), _vm._v("(いる場合のみ)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "help-modal",
    attrs: {
      "id": "proposeHelpModal"
    }
  }, [_c('div', {
    staticClass: "help-modal__body bg03",
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    }
  }, [_c('h4', {
    staticClass: "heading_01 mb25"
  }, [_vm._v("こんな投稿"), _c('br'), _vm._v("待ってるニャン♪")]), _c('div', {
    staticClass: "box_01 help-modal__body__txt -proposal"
  }, [_c('p', [_vm._v("お客様は勿論、会社のみんなにも、「居心地のいい、素敵な会社だ」と思ってもらえるような、素敵なアイディア待ってるニャン♪")]), _c('p', [_vm._v("みんなの声を反映して、より一層毎日を快適に過ごせるようにしたいんだニャン♪")]), _c('p', [_vm._v("投稿した提案は、みんなで見れるようにタイムラインに掲載されるニャン♪")]), _c('p', [_vm._v("法律などの問題から、実現が現時点では難しい提案については、個別にお返事を差し上げますだニャン！")])]), _c('button', {
    staticClass: "btn01 moral-going__modal-btn",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('span', [_vm._v("閉じる")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "heading_01 mb40"
  }, [_vm._v("提案内容を"), _c('br'), _vm._v("確認中だニャン♪")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box_01 help-modal__body__txt -proposal"
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("内容を確認しますニャン♪")]), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("↓")]), _c('p', {
    staticClass: "bold",
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "0px"
    }
  }, [_vm._v("タイムラインに掲載して")]), _c('p', {
    staticClass: "bold",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("みんなに提案を共有")]), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("or")]), _c('p', {
    staticClass: "bold",
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "0px"
    }
  }, [_vm._v("現時点で難しい提案には")]), _c('div', {
    staticClass: "mb10"
  }, [_c('span', {
    staticClass: "bold",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("個別にお返事します")]), _c('span', [_vm._v("ニャン♪")])]), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("待っててだニャン！")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading"
  }, [_c('button', {
    staticClass: "hide",
    attrs: {
      "id": "loadingModalButton",
      "type": "button",
      "data-backdrop": "static",
      "data-toggle": "modal",
      "data-target": "#loadingModal"
    }
  }, [_vm._v("モーダル発火用")]), _c('div', {
    staticClass: "help-modal",
    attrs: {
      "id": "loadingModal"
    }
  }, [_c('div', {
    staticClass: "help-modal__body bg03",
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    }
  }, [_c('h4', {
    staticClass: "heading_01 mb25"
  }, [_vm._v("投稿中だニャン♪")]), _c('div', {
    staticClass: "box_01 help-modal__body__txt -login-done"
  }, [_c('p', [_vm._v("暫くそのまま"), _c('br'), _vm._v("お待ちくださいだニャン！")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1c8749db!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/propose-edit.pug
// module id = 1380
// module chunks = 1